module.exports = __webpack_public_path__ + "static/media/logohoz-white.8fab112b.png";